import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateEventPopupComponent } from 'src/app/core/check/create-event-popup/create-event-popup.component';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from "@angular/router";
import { Constants } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { DashboardService } from 'src/app/services/dashboard.service';
import moment from 'moment';
import { AetStateService } from 'src/app/services/aet-state.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-add-event-button',
  templateUrl: './add-event-button.component.html',
  styleUrls: ['./add-event-button.component.scss'],
  standalone: false // NOSONAR
})
export class AddEventButtonComponent implements OnInit {
  successMessage: any;
  errorMessage: any;
  addRouteEventForm: FormGroup;
  submitted: boolean;
  toyotaGUID: string;
  statusList: any[] = [];
  eventProbTypeList: any[] = [];
  logisticPartnerList: any[] = [];
  eventList: any[] = [];
  responseOnLoad: any;
  commentsRequired: boolean = false;
  eventTypes: any;
  problemTypeList: any;
  eventProblemMapping: any;
  isAccessible = true;
  color = 'blue';
  checked = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly DatePipe: DatePipe,
    private readonly router: Router,
    public constants: Constants,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly dashboardService: DashboardService,
    private readonly aetStateService: AetStateService
  ) { }

  ngOnInit(): void {
    // this.checkRoles();
    this.submitted = false;
    this.toyotaGUID = '';
    this.toyotaGUID = localStorage.getItem('toyotaGUID');
    this.creareSafetyRouteForm();
    this.addEventDataLoad();
  }

  // async checkRoles() {
  //   await this.aetStateService.getRoles();
  //   const roles = this.aetStateService.getroleState();
  //   const userRoles = JSON?.parse(roles);
  //   if(userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
  //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
  //   userRoles.includes(this.constants.LIOS_UAC_AET_LP) || userRoles.includes(this.constants.LIOS_UAC_MTMUS_Planner)
  //     ||userRoles.includes(this.constants.LIOS_UAC_MTMUS_Negotiator)||userRoles.includes(this.constants.LIOS_UAC_Portal_Administrator)
  //     ||userRoles.includes(this.constants.LIOS_UAC_Reporting_Admin)||userRoles.includes(this.constants.LIOS_UAC_Reporting_User)
  //     ||userRoles.includes(this.constants.LIOS_UAC_Route_Planner)||userRoles.includes(this.constants.LIOS_UAC_SCV_Admin)
  //     ||userRoles.includes(this.constants.LIOS_UAC_Security_Admin)||userRoles.includes(this.constants.LIOS_UAC_TEMA_AF)
  //     ||userRoles.includes(this.constants.LIOS_UAC_TEMA_Budgeting)||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_AM)
  //     ||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist)||userRoles.includes(this.constants.LIOS_UAC_TEMA_Purchasing)
  //     ||userRoles.includes(this.constants.LIOS_UAC_TEMA_LC)||userRoles.includes(this.constants.LIOS_UAC_TPT_Admin)
  //     ||userRoles.includes(this.constants.LIOS_UAC_TSCS_Admin)||userRoles.includes(this.constants.LIOS_UAC_WT_Administrator))){
  //     this.isAccessible = true;
  //   }
  //   else{
  //     this.router.navigate([`/home`]);
  //   }
  //   // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
  //   //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
  //   //   // this.isAccessible = true;
  //   // } else {
  //   //   this.router.navigate([`/home`]);
  //   // }
  // }

  get form() {
    return this.addRouteEventForm.controls;
  }
  creareSafetyRouteForm() {
    this.addRouteEventForm = this.formBuilder.group({
      eventType: ['', [Validators.required]],
      plannedUnload: ['', [Validators.required]],
      routeName: ['', [Validators.required]],
      status: ['', Validators.required],
      problemType: ['', [Validators.required]],
      logisticsPartner: ['', [Validators.required]],
      incidentDateTime: [''],
      incidentTime: [''],
      trailer: [''],
      commentsInput: [''],
    });
  }
  addEventDataLoad() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.dashboardService.getAddEventData()?.subscribe(
      (response) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        if (response) {
          this.responseOnLoad = response;
          this.logisticPartnerList = this.responseOnLoad.logisticsPartners;
          const sortedPartners = [...this.logisticPartnerList];

          sortedPartners.sort((a, b) => {
            const valueA = a.vendorName?.toLowerCase() ?? '';
            const valueB = b.vendorName?.toLowerCase() ?? '';

            if (valueA < valueB) {
              return -1;
            }

            if (valueA > valueB) {
              return 1;
            }

            return 0;
          });

          this.logisticPartnerList = sortedPartners;

          this.statusList = this.responseOnLoad.eventStatuses;
          const sortedEvents1 = [...this.statusList];

          sortedEvents1.sort((a, b) => {
            const valueA = a.description?.toLowerCase() ?? '';
            const valueB = b.description?.toLowerCase() ?? '';

            if (valueA == 'other') {return 1;}  // NOSONAR
            if (valueB == 'other') {return -1;}  // NOSONAR

            return valueA.localeCompare(valueB);
          });

          this.statusList = sortedEvents1;
          this.eventTypes = this.responseOnLoad.eventTypes;
          const sortedEvents = [...this.eventTypes];

          sortedEvents.sort((a, b) => {
            const valueA = a.description?.toLowerCase() ?? '';
            const valueB = b.description?.toLowerCase() ?? '';

            if (valueA == 'other') {return 1;}  // NOSONAR
            if (valueB == 'other') {return -1;}  // NOSONAR

            return valueA.localeCompare(valueB);
          });

          this.eventTypes = sortedEvents;
          this.problemTypeList = this.responseOnLoad.problemTypes;
          this.eventProblemMapping = this.responseOnLoad.eventProblemMappings;
          this.eventTypes.forEach((element) => {
            const mapping = {
              eventTypeId: element.eventTypeId,
              eventType: element.description,
              problemTypes: [],
            };
            const problemIds = this.eventProblemMapping.filter(
              (value: any) => value.eventTypeId == element.eventTypeId  // NOSONAR
            );
            const problems = [];
            problemIds.forEach((element2) => {
              const id = element2.problemTypeId;
              const type = this.problemTypeList.find(
                (value) => value.problemTypeId == id  // NOSONAR
              );
              if (type != undefined) {  // NOSONAR
                problems.push(type);
              }
            });
            mapping.problemTypes = problems;
            this.eventProbTypeList.push(mapping);
          });
        }
      },
      (err) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        console.info(err);
        this.errorMessage = this.constants.APIErrorMessage;
      }
    );
  }
  onEventTypeSelection(_event: any) {
    this.eventList = [];
    const eventTypId = this.form['eventType'].value.eventTypeId;
    this.form['problemType'].patchValue('');
    for (let i = 0; i < this.eventProbTypeList.length; i++) {
      if (this.eventProbTypeList[i].eventTypeId == eventTypId) {  // NOSONAR
        for (
          let j = 0;
          j < this.eventProbTypeList[i].problemTypes.length;
          j++
        ) {
          this.eventList.push(this.eventProbTypeList[i].problemTypes[j]);
          const sortedEvents = [...this.eventList];

          sortedEvents.sort((a, b) => {
            const valueA = a.description?.toLowerCase() ?? '';
            const valueB = b.description?.toLowerCase() ?? '';

            if (valueA == 'other') {return 1;}  // NOSONAR
            if (valueB == 'other') {return -1;}  // NOSONAR

            return valueA.localeCompare(valueB);
          });

          this.eventList = sortedEvents;

        }
        break;
      }
    }
    if ( this.form['eventType'].value.eventTypeId == 10 || this.form['eventType'].value.eventTypeId == 11 || this.form['eventType'].value.eventTypeId == 7 ) {  // NOSONAR

      this.commentsRequired = true;
      this.form['commentsInput'].setValidators([Validators.required]);
      this.form['commentsInput'].updateValueAndValidity();
    } else {
      this.commentsRequired = false;
      this.form['commentsInput'].clearValidators();
      this.form['commentsInput'].updateValueAndValidity();
    }
  }
  onDateSelection() {
    console.info('Incident date', this.form['incidentDateTime'].value);
    this.form['incidentTime'].setValue(moment(new Date()).format('HH:mm'));
  }
  statusChange() {
    console.info('status', this.form['status'].value);
  }
  onSubmit() {
    this.submitted = true;

    if (!this.createValidations()) {
      return;
    }
    this.formatValidation();
  }
  createValidations() {
    this.successMessage = null;
    this.errorMessage = null;
    let returnVal = true;
    if (this.addRouteEventForm.invalid) {
      returnVal = false;
    }
    return returnVal;
  }
  verifyRouteFormat(value) {
    const s2 = [];
    const s3 = [];
    const routeName = value.trim();
    const s = routeName.split('-');
    if (s.length != 2) {  // NOSONAR
      return false;
    }
    s[2] = s.length > 0 ? s[0] : []
    if (s2.length > 7) {
      return false;
    }
    s[3] = s.length > 1 ? s[1] : []
    if (s3.length > 2) {
      return false;
    }
    return true;
  }
  formatValidation() {

    const routeNameId = this.addRouteEventForm.controls['routeName'].value;
    const unload = this.addRouteEventForm.controls['plannedUnload'].value;
    const today = new Date().getTime();
    const unloadTime = unload ? new Date(unload).getTime() : null;
    if (routeNameId && routeNameId.toUpperCase() != 'XXX-01') { // NOSONAR
      if (this.verifyRouteFormat(routeNameId) == false) {  // NOSONAR
        this.errorMessage = 'Please Enter a valid Route Name (XXX-YY)';
        return;
      }

      if (unload && unloadTime < today) {
        this.popup();
      } else {

        this.onCreateAPI();
      }
    } else if (unload && unloadTime < today) {
      this.popup();
    } else {

      this.onCreateAPI();

    }
  }
  onCreateAPI() {
    console.info("null", this.form['incidentTime'].value != null); // NOSONAR
    console.info("empty", this.form['incidentTime'].value != ''); // NOSONAR
    if (
      this.form['incidentTime'].value != '' // NOSONAR
    ) {
      if ( this.form['incidentDateTime'].value == '' || this.form['incidentDateTime'].value == null ) {  // NOSONAR
        console.info('Bad request');
        this.errorMessage = 'Please select the ETA Date';
      }
      else {

        this.createCall();
      }
    } else {

      this.createCall();
    }
  }
  createCall() {
    console.info('time value', this.form['incidentTime'].value);
    const routeName = this.addRouteEventForm.controls['routeName'].value;
    const plannedUnload = this.form['plannedUnload'].value
      ? `${this.DatePipe.transform(
        this.form['plannedUnload'].value,
        'MM-dd-yyyy'
      )}${' '}${'00:00'}${':00'}`
      : '';
    const payload = {
      eventTypeId: this.form['eventType'].value.eventTypeId,
      arrival: plannedUnload,
      puRoute: routeName.toUpperCase(),
      problemTypeId: this.form['problemType'].value.problemTypeId,
      transportationProviderId: this.form['logisticsPartner'].value.vendorId,
      eta: this.form['incidentDateTime'].value
        ? `${this.DatePipe.transform(
          this.form['incidentDateTime'].value,
          'MM-dd-yyyy'
        )}${' '}${this.form['incidentTime'].value}${':00'}`
        : '',
      eventTrailer: this.form['trailer'].value,
      comments: this.form['commentsInput'].value,
      statusId: this.form['status'].value.statusId,
      isUnplannedRoute: this.checked ? 1 : 0
    };
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userReqDto = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    const createEventRequest = { event: payload, userReqDto };
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    this.dashboardService.addEventSave(createEventRequest).subscribe(
      (res) => {
        this.ngxUiLoaderService?.stop(CommonConstant.loader);
        if (res) {
          if (res.includes('Successfully created!')) {

            this.router.navigate(['/dashboard']);
          } else {
            this.submitted = false;
            this.errorMessage = res;
          }
        }
      },
      (error) => {
        this.ngxUiLoaderService?.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        console.info(error);
      }
    );
  }
  popup() {
    const dialogRef = this.dialog?.open(CreateEventPopupComponent, {
      width: '50%',
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data == 'proceed') {  // NOSONAR
        this.onCreateAPI();
      }
    });
  }
  onCancel() {
    localStorage.setItem('backFlag', 'true');
    this.router.navigate(['/dashboard']);

  }
  close() {
    this.errorMessage = null;
    this.successMessage = null;
  }

}
